import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Phone, BookOpen, MessageSquare } from 'lucide-react';

export const ComingSoonPage = ({ title, topic }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1020]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0B1020]/95 backdrop-blur-sm border-b border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="text-xl font-bold text-[#F8FAFC]">Bryan Maldonado</Link>
            <div className="flex items-center gap-4">
              <a href="tel:801-651-8363" className="hidden sm:flex items-center gap-2 text-[#94A3B8] hover:text-[#F8FAFC] transition-colors">
                <Phone size={18} />
                <span>801-651-8363</span>
              </a>
              <Button onClick={() => navigate('/calculator')} className="bg-[#3B82F6] hover:bg-[#2563EB] text-white">
                90-Day Forecast
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 min-h-[80vh] flex items-center">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="bg-[#121A2B] border-[#1E293B] p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#F8FAFC] mb-6">
              This program is coming soon.
            </h1>
            <p className="text-lg text-[#94A3B8] mb-8">
              In the meantime, if you have questions about {topic}, text or call Bryan directly — he responds personally.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => window.location.href = 'sms:8016518363'}
                className="bg-[#22C55E] hover:bg-[#16A34A] text-white text-lg py-6 h-auto"
                data-testid="text-bryan-btn"
              >
                <MessageSquare className="mr-2" size={20} />
                Text Bryan — 801-651-8363
              </Button>
              <Button
                onClick={() => navigate('/blog')}
                variant="outline"
                className="border-[#3B82F6] bg-[#3B82F6]/10 hover:bg-[#3B82F6]/20 text-[#3B82F6] text-lg py-6 h-auto"
                data-testid="browse-blog-btn"
              >
                <BookOpen className="mr-2" size={20} />
                Browse Weight Loss Resources
              </Button>
            </div>
          </Card>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 sm:px-6 lg:px-8 border-t border-[#1E293B]">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-[#94A3B8] mb-4">© 2024 Bryan Maldonado. All rights reserved.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="tel:801-651-8363" className="text-[#94A3B8] hover:text-[#F8FAFC] transition-colors">
              801-651-8363
            </a>
            <span className="text-[#94A3B8] hidden sm:block">|</span>
            <a href="mailto:Bryan@DirectMeds.com" className="text-[#94A3B8] hover:text-[#F8FAFC] transition-colors">
              Bryan@DirectMeds.com
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Men's Hormone Support Page
export const MensHormoneSupport = () => (
  <ComingSoonPage 
    title="Men's Hormone Support" 
    topic="Men's Hormone Support" 
  />
);

// Hair Health Page
export const HairHealth = () => (
  <ComingSoonPage 
    title="Hair Health" 
    topic="Hair Health" 
  />
);

// Energy & Metabolism Page
export const EnergyMetabolism = () => (
  <ComingSoonPage 
    title="Energy & Metabolism" 
    topic="Energy & Metabolism" 
  />
);

export default MensHormoneSupport;
